// extracted by mini-css-extract-plugin
export default {"eventTypesModal":"styles_eventTypesModal__9DokB","wrapper":"styles_wrapper__Nimkl","title":"styles_title__oQ3oj"};